import { render, staticRenderFns } from "./SendGemsModal.vue?vue&type=template&id=9e7a8d22&"
import script from "./SendGemsModal.vue?vue&type=script&lang=js&"
export * from "./SendGemsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports